const DatasModule = {
    state: {
        maiorData: undefined,
        menorData: undefined
    },
    getters: {
        getDatasPeriodo(state) {
            return {
                maiorData: state.maiorData,
                menorData: state.menorData
            };
        }
    },
    mutations: {
        setDatas(state, datas) {
            state.maiorData = datas.maiorData;
            state.menorData = datas.menorData;
        }
    },
    actions: {
        
    }
}

export default DatasModule;